/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import 'firebase/analytics';
import { FireService } from './fire.service';
import { Events } from './analytics/events';
// import { version } from '../../../package.json';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
    Analytics,
    CustomParams,
    getAnalytics,
    setUserId,
    setUserProperties,
} from 'firebase/analytics';

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    private readonly analytics: Analytics;
    readonly events: Events;

    private userProperties: UserProperties = {
        AppId: null,
        AppVersion: null,
        Backdoor: null,
        ProviderId: null,
        Production: null,
    };

    constructor(fire: FireService, router: Router) {
        this.analytics = getAnalytics(fire.app);
        this.events = new Events(this.analytics);

        this.updateUserProperties({});
        this.updateAppInfo();

        // navigation handling
        router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
                const navigationEndEvent = event as NavigationEnd;
                this.events.navigate({
                    Id: navigationEndEvent.id.toString(),
                    Url: navigationEndEvent.url,
                    UrlAfterRedirects: navigationEndEvent.urlAfterRedirects,
                });
            });
    }

    setUser(userId: string | null, properties: SetUserProperties | null) {
        setUserId(this.analytics, userId as string);
        if (properties === null) {
            properties = {
                ProviderId: null,
            };
        }
        this.updateUserProperties(properties);
    }

    setBackdoorUserProperties(properties: BackdoorUserProperties) {
        this.updateUserProperties(properties);
    }

    private updateUserProperties(properties: InternalUserProperties) {
        Object.assign(this.userProperties, properties);
        setUserProperties(this.analytics, properties as CustomParams);
    }

    private updateAppInfo() {
        this.updateUserProperties({
            AppId: (this.analytics.app.options as any).appId,
            AppVersion: environment.version,
            Production: environment.production ? 1 : 0,
        } as AppInfoUserProperties);
    }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface InternalUserProperties {}

export interface SetUserProperties extends InternalUserProperties {
    ProviderId: string | null;
}

export interface BackdoorUserProperties extends InternalUserProperties {
    Backdoor: number | null;
}

export interface AppInfoUserProperties extends InternalUserProperties {
    AppId: string | null;
    AppVersion: string | null;
    Production: number | null;
}

export interface UserProperties
    extends SetUserProperties, BackdoorUserProperties, AppInfoUserProperties {}
